export const API_SESSION_STORAGE_KEY = 'workfit_api_session';
export const API_UNAUTHORIZED_EVENT = 'workfit:api-unauthorized';

interface StoredApiSession {
  token: string;
  expiresAt: string;
  userType: 'worker' | 'admin';
  userId: string;
}

function getSessionStorage(): Storage | null {
  return typeof window !== 'undefined' ? window.sessionStorage : null;
}

function readApiSession(): StoredApiSession | null {
  const storage = getSessionStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(API_SESSION_STORAGE_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw) as StoredApiSession;
    if (!session.token || !session.userId || !session.userType || !session.expiresAt) {
      storage.removeItem(API_SESSION_STORAGE_KEY);
      return null;
    }
    if (Date.parse(session.expiresAt) <= Date.now()) {
      storage.removeItem(API_SESSION_STORAGE_KEY);
      return null;
    }
    return session;
  } catch {
    storage.removeItem(API_SESSION_STORAGE_KEY);
    return null;
  }
}

export function storeApiSession(
  token: string,
  expiresAt: string,
  userType: 'worker' | 'admin',
  userId: string
): void {
  const storage = getSessionStorage();
  if (!storage || !token || !expiresAt || !userId) return;
  const session: StoredApiSession = { token, expiresAt, userType, userId };
  storage.setItem(API_SESSION_STORAGE_KEY, JSON.stringify(session));
}

export function getApiSessionToken(): string {
  return readApiSession()?.token || '';
}

export function clearApiSession(): void {
  getSessionStorage()?.removeItem(API_SESSION_STORAGE_KEY);
}

export function notifyApiUnauthorized(): void {
  clearApiSession();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(API_UNAUTHORIZED_EVENT));
  }
}
